import React from 'react';
import PropTypes from 'prop-types';
import Button from '../Button';
import Icon from '../Icon';
import { getAriaLabel } from './utils/iconButtonHelpers';
import { resolveIconClass } from '../Button/utils/buttonHelpers';

const IconButton = ({ icon, onClick, disabled, variant, size, ariaLabel, color, className }) => {
  const label = getAriaLabel(ariaLabel, icon);

  return (
    <Button
      variant={variant || 'text'}
      size={size}
      onClick={onClick}
      disabled={disabled}
      aria-label={label}
      title={label}
      className={className}
      iconButton // custom prop we will add to Button to enforce icon-only padding
    >
      <Icon className={resolveIconClass(icon)} size={size} color={color || 'inherit'} />
    </Button>
  );
};

IconButton.propTypes = {
  icon: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  variant: PropTypes.string,
  size: PropTypes.oneOf(['xs', 'sm', 'md', 'lg']),
  ariaLabel: PropTypes.string,
  color: PropTypes.string,
  className: PropTypes.string,
};

IconButton.defaultProps = {
  onClick: undefined,
  disabled: false,
  variant: 'text',
  size: 'md',
  ariaLabel: undefined,
  color: undefined,
  className: '',
};

export default IconButton;



// WEBPACK FOOTER //
// ./src/design-system/atoms/IconButton/IconButton.jsx